import React from 'react';
import Link from 'next/link';
import PropTypes from 'prop-types';

export const CustomLink = ({
  cypress,
  stat,
  href,
  styledLink: StyledLink,
  children,
  onClick,
  prefetch = false,
  ...rest
}) => {
  if (!href) return null;

  if (!StyledLink) {
    return (
      <Link
        href={href}
        data-cy={cypress}
        data-stat={stat}
        onClick={onClick}
        // locale={false} prevents Next.js from auto-prefixing hrefs with locale
        // This is needed because we use subdomain-based routing (ru.bina.az)
        // and middleware rewrites, not path-based locale prefixes
        locale={false}
        prefetch={prefetch}
        {...rest}
      >
        {children}
      </Link>
    );
  }

  return (
    <StyledLink
      as={Link}
      href={href}
      data-cy={cypress}
      data-stat={stat}
      onClick={onClick}
      locale={false}
      prefetch={prefetch}
    >
      {children}
    </StyledLink>
  );
};

CustomLink.propTypes = {
  cypress: PropTypes.string,
  stat: PropTypes.string,
  href: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  prefetch: PropTypes.bool,
  styledLink: PropTypes.elementType,
  children: PropTypes.node
};
